'use strict';

const isSmallView = require('./modules/helpers/isSmallView');
const advent = require('./advent');
const greenfriday = require('./greenfriday');
const giftsetfastlane = require('./giftsetfastlane');
const gtm = require('./modules/google').tagManager;
const easter = require('./easter/easter');

const accordionWrapper = '.js-pdp-accordion-wrapper';

function handleAccordion() {
    const $heading = $('.js-acc-head');
    const $headingInner = $('.js-acc-head-inner');
    const $faqAccordionHead = $('.js-acc-head-button');

    $heading.on('click', function (e, shouldSkipDataLayerPush) {
        accordionToggle($heading, this, shouldSkipDataLayerPush);
    });

    $headingInner.on('click', function () {
        accordionToggle($headingInner, this);
    });

    $('.js-faq-button').on('click', function () {
        advent.pushAdventDataLayerDataForFAQBlock('show more');
    });

    $faqAccordionHead.on('click', faqAccordionToggle);

    if ($faqAccordionHead.length) {
        const $firstFaqItem = $('.js-faq-acc-head').parent().first();
        $firstFaqItem.find('.js-acc-head-button').trigger('click', true);
    }
}


function accordionToggle($selector, context, shouldSkipDataLayerPush) {
    const $textHolderParent = $(context).closest('.text-holder');
    const $gridHolderParent = $(context).closest('.grid-wrap');

    if (!$(context).hasClass('open')) {
        if (isSmallView()) {
            $selector.removeClass('open').next().stop().slideUp().attr('aria-hidden', 'true');
            $selector.parent().attr('aria-haspopup', 'true');
        }
        $(context).addClass('open').next().stop().slideDown('slow', function() {
            if ($textHolderParent.hasClass('js-equal-height')) {
                $gridHolderParent.animate({height: $gridHolderParent.height() + $(context).siblings()[0].offsetHeight});
            }
        }).removeAttr('aria-hidden');

        $(context).parent().removeAttr('aria-haspopup');
        $(context).triggerHandler('opened');
        if (!shouldSkipDataLayerPush) {
            gtm.pushPDPTabsEvent($(context), accordionWrapper);
        }
    } else {
        if ($textHolderParent.hasClass('js-equal-height')) {
            $gridHolderParent.animate({height: $gridHolderParent.height() - $(context).siblings()[0].offsetHeight});
        }

        $(context).removeClass('open').next().stop().slideUp().attr('aria-hidden', 'true');
        $(context).parent().attr('aria-haspopup', 'true');
    }
}

const faqAccordionToggle = (el, skipPushEvent) => {
    const $this = $(el.target);
    const faqHeadClass = '.js-faq-acc-head';
    const faqContentClass = '.js-faq-acc-content';
    const $parent = $this.parent(faqHeadClass);
    const $siblings = $parent.parent().siblings();
    const isExpanded = $parent.hasClass('open-acc');

    if (!isExpanded) {
        $siblings.find(faqHeadClass).removeClass('open-acc').attr('aria-expanded', 'false');
        $siblings.find(faqContentClass).stop().slideUp().attr('aria-hidden', 'true');
        $parent.addClass('open-acc').attr('aria-expanded', 'true');
        $parent.siblings(faqContentClass).stop().slideDown().attr('aria-hidden', 'false');
        const eventLabel = $parent.data('event-label');
        if (eventLabel && !skipPushEvent) {
            advent.pushAdventDataLayerDataForFAQBlock(eventLabel);
            greenfriday.pushDataLayerDataForFAQBlock(eventLabel);
            giftsetfastlane.pushDataLayerEventForFAQBlock(eventLabel);
            easter.pushDataLayerDataForFAQBlock(eventLabel);
        }
    } else {
        $parent.removeClass('open-acc').attr('aria-expanded', 'false');
        $parent.siblings(faqContentClass).stop().slideUp().attr('aria-hidden', 'true');
    }
};

function initializeEvents() {
    handleAccordion();
}

const customAccordion = {
    init: function() {
        initializeEvents();
    }
};

module.exports = customAccordion;
